import React from 'react';
import styles from '../styles/Users.module.css';

const UserTable = ({ users, onEdit, onDelete, onAdd }) => {
  return (
    <div className={styles.userTableWrapper}>
      {onAdd && (
        <button className={styles.addButton} onClick={onAdd} type="button">Add User</button>
      )}
      <table className={styles.userTable}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Role</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.name}</td>
              <td>{user.phone}</td>
              <td>{user.email}</td>
              <td>{user.role}</td>
              <td>
                <span className={user.status === 'Active' ? styles.activeBadge : styles.inactiveBadge}>
                  {user.status}
                </span>
              </td>
              <td>
                <button className={styles.editBtn} type="button" onClick={() => onEdit && onEdit(user)}>Edit</button>
                <button className={styles.deleteBtn} type="button" onClick={() => onDelete && onDelete(user.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
